<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text mb-4"
          style="background: transparent" >
          <v-toolbar-title>CONFIGURAÇÕES</v-toolbar-title>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <h3>COMPRAS:</h3>
      </v-flex>
      <v-flex xs12 class="ma-4">
        <v-tooltip top>
          <v-btn color="primary" block large class="mb-3 text-xs-start" @click="() => toogleCashPosto()" slot="activator">
            <v-icon class="mr-2 material-icons">attach_money</v-icon>
            {{posto.tem_cashposto ? 'Desativar' : 'Ativar'}} Cashposto
          </v-btn>
          <h2>
            Com essa função ativa os clientes do seu posto ganharão um percentual de cashback em cima de cada compra,
            no lugar de ganhar desconto no valor da compra, seus cliente ganharão um valor de cashback que só pode ser usado no seu posto.
          </h2>
        </v-tooltip>
        <v-tooltip top>
          <v-btn color="primary" block large class="mb-3 text-xs-start" @click="dialogDestino = true" slot="activator">
            <v-icon class="mr-2 material-icons">wallet</v-icon>
            Escolher destino cashposto
          </v-btn>
          <h2>
            Escolha onde seus clientes poderão usar o cashback ganho no seu posto.
          </h2>
        </v-tooltip>
        <v-tooltip top>
          <v-btn color="primary" block large class="mb-3" @click="() => toogleReceberPosPago()" slot="activator">
            <v-icon class="mr-2">payments</v-icon>
            {{posto.recebe_pospago ? 'Desativar' : 'Ativar'}} recebimento no posto
          </v-btn>
          <h2>
            Com essa função ativa seus clientes poderão realizar o pagamento de seus vouchers direto no seu posto.
          </h2>
        </v-tooltip>
        <v-tooltip top>
          <v-btn
            color="primary"
            block
            large
            class="mb-3"
            @click="atualizarPosto({ limitar_geolocalizacao: !posto.limitar_geolocalizacao })"
            slot="activator"
          >
            <v-icon class="mr-2">location_on</v-icon>
            {{posto.limitar_geolocalizacao ? 'Desativar' : 'Ativar'}}  bloqueio de geolocalização
          </v-btn>
          <h2>
            Com essa função ativa, se seus clientes estiverem localizados fora área do seu posto,
            eles serão impedidos de realizar compras de vouchers para pagamento no posto.
          </h2>
        </v-tooltip>
        <v-tooltip top v-if="posto.is_white_label">
          <v-btn
            color="primary"
            block
            large
            class="mb-3"
            @click="dialogLimite = true"
            slot="activator"
          >
            <v-icon class="mr-2">do_not_disturb_alt</v-icon>
             Limete de compra
          </v-btn>
          <h2>
            Configurações de Limetes de Compra
          </h2>
        </v-tooltip>
        <v-btn
          color="primary"
          block
          large
          class="mb-3"
          @click="atualizarPosto({ permitir_cliente_gerar_voucher: !posto.permitir_cliente_gerar_voucher })"
          disabled
        >
          <v-icon class="mr-2">contacts</v-icon>
          {{posto.permitir_cliente_gerar_voucher ? 'Desativar' : 'Ativar'}} selecão de frentista por cliente
        </v-btn>
      </v-flex>

      <v-flex xs12 class="mt-4">
        <h3>PROGRAMAS:</h3>
      </v-flex>
      <v-flex xs12 class="ma-4">
        <v-btn color="primary" block large class="mb-3 text-xs-start" @click="dialogFidelidade = true">
          <v-icon class="mr-2 material-icons">loyalty</v-icon>
          Fidelidade
        </v-btn>
        <v-btn color="primary" block large class="mb-3" @click="dialogAssinatura = true">
          <v-icon class="mr-2">local_atm</v-icon>
          Assinatura
        </v-btn>
      </v-flex>
      <v-flex xs12 class="mt-4">
        <h3>Preferencias:</h3>
      </v-flex>
      <v-flex xs12 class="ma-4">
        <v-tooltip top v-if="posto.is_white_label && posto.is_simultaneo">
          <v-btn
            color="primary"
            block
            large
            class="mb-3"
            @click="atualizarPosto({ exclusive_to_white_label: !posto.exclusive_to_white_label })"
            slot="activator"
          >
          {{ posto.exclusive_to_white_label ? 'Desativar' : 'Ativar' }} Ofertas Exclusivas Para App do Posto
          </v-btn>
          <h2>
            {{ posto.exclusive_to_white_label ? 'Com essa função desativa, as ofertas criadas para o app Apetrus aparecerão no app do seu posto.' : 'Com essa função ativa, as ofertas criadas para o app Apetrus não aparecerão no app do seu posto.' }}
          </h2>
        </v-tooltip>
        <v-tooltip top v-if="posto.rede_sindicato">
          <v-btn
            color="primary"
            block
            large
            class="mb-3"
            @click="atualizarPosto({ exclusive_to_union: !posto.exclusive_to_union })"
            slot="activator"
          >
            {{ posto.exclusive_to_union ? 'Desativar' : 'Ativar' }} Ofertas Exclusivas Para App do Sindicato
          </v-btn>
          <h2>
            {{ posto.exclusive_to_union ? 'Com essa função desativa, as ofertas criadas para o app Apetrus aparecerão no app do sindicato.' : 'Com essa função ativa, as ofertas criadas para o app Apetrus não aparecerão no app do sindicato.' }}
          </h2>
        </v-tooltip>
          <v-tooltip top>
            <v-btn
              color="primary"
              block
              large
              class="mb-3"
              @click="atualizarPosto({ avaliacao_frentista: !posto.avaliacao_frentista })"
              slot="activator"
            >
              {{ posto.avaliacao_frentista ? 'Desativar' : 'Ativar' }} Avaliação do Frentista
            </v-btn>
            <h2>
              {{ posto.avaliacao_frentista ? 'Com essa função desativada, a avaliação do frentista no momento da compra não será solicitada.' : 'Com essa função ativa, a avaliação do frentista será solicitada no momento da compra.' }}
            </h2>
          </v-tooltip>
         <v-layout
            row
            align-center
            justify-center
            v-if="posto.avaliacao_frentista"
            class="mb-3"
          >
            <v-flex xs8>
              <v-text-field
                v-model="perguntaAvaliacao"
                label="Selecione a pergunta que você deseja fazer no momento da avaliação"
                :disabled="!editandoPergunta"
                outlined
                dense
                class="mr-3"
              />
            </v-flex>
            <v-flex xs4>
              <div class="d-flex justify-center align-center">
                <v-btn
                  color="primary"
                  @click="salvarPerguntaAvaliacao"
                  v-if="editandoPergunta"
                  class="mx-2"
                  large
                >
                  Confirmar
                </v-btn>
                <v-btn
                  color="error"
                  @click="excluirPerguntaAvaliacao"
                  v-else
                  class="mx-2"
                  large
                >
                  Excluir
                </v-btn>
                <v-btn
                  color="secondary"
                  @click="editandoPergunta = true"
                  v-if="!editandoPergunta"
                  class="mx-2"
                  large
                >
                  Editar
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-tooltip top v-if="posto.avaliacao_frentista">
            <v-btn
              color="primary"
              block
              large
              class="mb-3"
              @click="atualizarPosto({ avaliacao_depois: !posto.avaliacao_depois })"
              slot="activator"
            >
              {{ posto.avaliacao_depois ? 'Avaliação Antes' : ' Avaliação Depois' }} da compra
            </v-btn>
            <h2>
              {{ posto.avaliacao_depois ? 'A avaliação do frentista será solicitada no momento da compra.' : ' A avaliação do frentista será solicitada depois da compra.' }}
            </h2>
          </v-tooltip>
      </v-flex>
      <v-flex xs12 class="mt-4">
        <h3>Cadastro de alertas ou noticias:</h3>
      </v-flex>
     <v-flex xs12 class="ma-4">
       <v-tooltip top>
         <v-btn
           color="primary"
           block
           large
           class="mb-3 text-xs-start"
           @click="cadastrarNoticia()"
           slot="activator"
         >
           <v-icon class="mr-2">notifications</v-icon>
           Cadastrar Notícia ou Alerta
         </v-btn>
         <h2>
           Crie alertas ou notícias que serão exibidos para os clientes da sua rede de postos.
         </h2>
       </v-tooltip>
     </v-flex>
    </v-layout>
    <v-dialog v-model="dialogFidelidade" v-if="dialogFidelidade" width="900">
      <cad-fidelidade @fechar="dialogFidelidade = false"/>
    </v-dialog>
    <v-dialog v-model="dialogAssinatura" v-if="dialogAssinatura" width="600">
      <programa-assinatura
        @fechar="dialogAssinatura = false"
        @showSnackbar="showSnackbar"
      />
    </v-dialog>
    <v-dialog v-model="dialogLimite" v-if="dialogLimite" width="700" scrollable>
        <dialog-limite-compra
          @fechar="dialogLimite = false"
        />
    </v-dialog>
    <v-dialog v-model="dialogDestino" v-if="dialogDestino" width="600" scrollable>
        <dialog-destino-cashposto
          @fechar="dialogDestino = false"
          @showSnackbar="showSnackbar"
        />
    </v-dialog>
    <dialognoticias
      v-model="dialogNoticias"
      v-if="dialogNoticias"
      :rede-id="posto && posto.rede ? posto.rede : null"
      @showSnackbar="showSnackbar"
    />
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import ProgramaAssinatura from '@/components/dialogs/ProgramaAssinatura'
import CadFidelidade from '@/components/cadastros/CadFidelidade'
import DialogLimiteCompra from '@/components/dialogs/LimiteCompra'
import DialogDestinoCashposto from '../../components/dialogs/DialogDestinoCashposto.vue'
import Dialognoticias from '../../components/dialogs/dialognoticias.vue'

export default {
  components: { CadFidelidade, ProgramaAssinatura, DialogLimiteCompra, DialogDestinoCashposto, Dialognoticias },
  data () {
    return {
      dialogAssinatura: false,
      dialogFidelidade: false,
      dialogLimite: false,
      dialogDestino: false,
      dialogNoticias: false,
      avaliacao_depois: null,
      perguntaAvaliacao: '',
      editandoPergunta: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  watch: {
    'posto.pergunta_avaliacao': {
      immediate: true,
      handler (val) {
        this.perguntaAvaliacao = val || ''
        this.editandoPergunta = false
      }
    }
  },
  methods: {
    showSnackbar (color, text) {
      this.snackbar.color = color
      this.snackbar.text = text
      this.snackbar.active = true
    },
    cadastrarNoticia (payload) {
      this.dialogNoticias = true
    },
    toogleReceberPosPago () {
      this.$store
        .dispatch('toogleReceberPosPago')
    },
    toogleCashPosto () {
      this.$store
        .dispatch('toogleCashPosto')
    },
    salvarPerguntaAvaliacao () {
      this.atualizarPosto({ pergunta_avaliacao: this.perguntaAvaliacao })
      this.editandoPergunta = false
    },
    excluirPerguntaAvaliacao () {
      this.perguntaAvaliacao = ''
      this.atualizarPosto({ pergunta_avaliacao: '' })
      this.editandoPergunta = false
    },
    atualizarPosto (data) {
      this.$store.dispatch('editarPosto', data).then(() => {
        this.$store.dispatch('escolherPosto', { cnpj: this.posto.cnpj })
      }).catch(() => {
        this.showSnackbar('error', 'Não foi possível realizar essa operação')
      })
    }
  }
}
</script>
<style>
  .lean-input, .lean-input .v-input--selection-controls__input {
    margin-right: 0;
    text-align: center;
  }
</style>
